<template>
  <div class="row mt-3">
    <extra-equipment-column
      :groups="filtered(leftEquipmentGroups)"
    />
    <extra-equipment-column
      :groups="filtered(rightEquipmentGroups)"
    />
  </div>
</template>

<script>
  import Vue from 'vue';
  import { Component, Prop } from 'vue-property-decorator';
  import { namespace } from 'vuex-class';
  import ExtraEquipmentColumn from './ExtraEquipmentColumn';

  const configuratorModule = namespace('configurator');
  @Component({
    components: {ExtraEquipmentColumn}
  })
  export default class ExtraEquipmentSelector extends Vue {
    @Prop() equipmentGroups;
    @Prop(Array) stockEqcodes;
    @Prop() stockSlug;

    @configuratorModule.State('stockMode') stockMode;
    @configuratorModule.State('selectedEquipments') selectedEquipments;
    @configuratorModule.Getter('getLeftEquipmentGroups') leftEquipmentGroups;
    @configuratorModule.Getter('getRightEquipmentGroups') rightEquipmentGroups;
    @configuratorModule.Action('loadEquipmentGroups') loadEquipmentGroups;
    @configuratorModule.Action('loadStock') loadStock;
    @configuratorModule.Mutation('setStockSlug') setStockSlug;

    created() {
      this.loadEquipmentGroups(this.equipmentGroups);

      if (this.stockSlug.length > 0) {
        this.loadStock({stockEqCodes: this.stockEqcodes, slug: this.stockSlug});
      }
    }

    filtered(groups) {
      if (this.stockMode) {
        return groups
          .filter(group => {
            return group.items
              .filter(equipment => {
                return this.selectedEquipments.includes(equipment.ADDID)
              }).length > 0
          })
      }

      return groups;
    }
  }
</script>
